module.exports = __webpack_public_path__ + "static/media/camera.80c0f1a1.svg";